
import React from 'react';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import FloatingWhatsApp from '@/components/FloatingWhatsApp';
import { Button } from "@/components/ui/button";
import { MessageCircle, Euro, Clock, Calendar, FileText, Search, Target, Users, Lightbulb, CheckCircle, Phone, Instagram, MessageSquare } from 'lucide-react';

const Consulting = () => {
  return <>
      <Navbar />
      <main className="bg-black min-h-screen">
        {/* Hero Section */}
        <section className="section-padding bg-gradient-to-br from-brand/10 to-black">
          <div className="container mx-auto px-6 md:px-8 lg:px-12">
            <div className="max-w-4xl mx-auto text-center">
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight">
                1:1 Συμβουλευτική
              </h1>
              <h2 className="text-2xl md:text-3xl font-bold text-white mb-8">με τον Mike Foto</h2>
              <p className="text-xl text-gray-300 mb-12 leading-relaxed">
                Προσωπική καθοδήγηση για δημιουργούς, freelancers και επιχειρήσεις που θέλουν να πάνε στο επόμενο επίπεδο.
              </p>
            </div>
          </div>
        </section>

        {/* Subtitle Section */}
        <section className="py-16 bg-dark-300">
          <div className="container mx-auto px-6 md:px-8 lg:px-12">
            <div className="max-w-4xl mx-auto text-center">
              <div className="flex justify-center mb-6">
                <MessageCircle className="w-12 h-12 text-brand" />
              </div>
              
              <p className="text-lg text-gray-300 leading-relaxed">Χρειάζεσαι στρατηγική, ξεκαθάρισμα ή χάρτη για να προχωρήσεις με σιγουριά; Μια 60λεπτη συνεδρία μαζί μου είναι αρκετή για να πάρεις ξεκάθαρη κατεύθυνση και συγκεκριμένο πλάνο, είτε ξεκινάς τώρα είτε θες να κάνεις scale.</p>
            </div>
          </div>
        </section>

        {/* Price & Format Section */}
        <section className="py-16 bg-black">
          <div className="container mx-auto px-6 md:px-8 lg:px-12">
            <div className="max-w-4xl mx-auto">
              <div className="flex justify-center mb-8">
                <Euro className="w-12 h-12 text-yellow-400" />
              </div>
              <h3 className="text-3xl font-bold text-white text-center mb-12">
                Τιμή & Format
              </h3>
              
              <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
                <div className="premium-card text-center">
                  <Euro className="w-8 h-8 text-yellow-400 mx-auto mb-4" />
                  <h4 className="text-lg font-bold text-white mb-2">Τιμή</h4>
                  <p className="text-gray-300">97€/ώρα</p>
                </div>
                
                <div className="premium-card text-center">
                  <Clock className="w-8 h-8 text-blue-400 mx-auto mb-4" />
                  <h4 className="text-lg font-bold text-white mb-2">Διάρκεια</h4>
                  <p className="text-gray-300">60 λεπτά μέσω Zoom ή Google Meet</p>
                </div>
                
                <div className="premium-card text-center">
                  <Calendar className="w-8 h-8 text-green-400 mx-auto mb-4" />
                  <h4 className="text-lg font-bold text-white mb-2">Διαθεσιμότητα</h4>
                  <p className="text-gray-300">Κατόπιν συνεννόησης</p>
                </div>
                
                <div className="premium-card text-center">
                  <FileText className="w-8 h-8 text-purple-400 mx-auto mb-4" />
                  <h4 className="text-lg font-bold text-white mb-2">Παράδοση</h4>
                  <p className="text-gray-300">Follow-up PDF με προτάσεις, εργαλεία & action plan</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* What's Included Section */}
        <section className="py-16 bg-dark-300">
          <div className="container mx-auto px-6 md:px-8 lg:px-12">
            <div className="max-w-4xl mx-auto">
              <div className="flex justify-center mb-8">
                <Search className="w-12 h-12 text-brand" />
              </div>
              <h3 className="text-3xl font-bold text-white text-center mb-12">
                Τι περιλαμβάνει η συνεδρία
              </h3>
              
              <div className="space-y-6">
                {["Ανάλυση της παρούσας κατάστασης (ατόμου ή επιχείρησης)", "Εντοπισμός των βασικών προβλημάτων ή ευκαιριών", "Δημιουργία πρακτικού πλάνου ενεργειών", "Καθοδήγηση σε εργαλεία, περιεχόμενο, funnels, positioning", "Προτάσεις marketing, πωλήσεων ή διαφημιστικής στρατηγικής", "Follow-up υλικό με προσαρμοσμένες σημειώσεις"].map((item, index) => <div key={index} className="flex items-start space-x-4">
                    <CheckCircle className="w-6 h-6 text-green-400 flex-shrink-0 mt-1" />
                    <p className="text-gray-300 text-lg">{item}</p>
                  </div>)}
              </div>
            </div>
          </div>
        </section>

        {/* Personal Support Section */}
        <section className="py-16 bg-black">
          <div className="container mx-auto px-6 md:px-8 lg:px-12">
            <div className="max-w-4xl mx-auto">
              <div className="flex justify-center mb-8">
                <Phone className="w-12 h-12 text-brand" />
              </div>
              <h3 className="text-3xl font-bold text-white text-center mb-12">
                Προσωπική Υποστήριξη (μετά τη συνεδρία)
              </h3>
              
              <div className="glass-card p-8">
                <p className="text-lg text-gray-300 mb-6">
                  Για 7 ημέρες μετά τη συνεδρία, θα έχεις πρόσβαση σε εμένα:
                </p>
                
                <div className="space-y-4">
                  <div className="flex items-center space-x-4">
                    <MessageSquare className="w-6 h-6 text-blue-400" />
                    <p className="text-gray-300">Για clarifications ή follow-up ερωτήσεις</p>
                  </div>
                  <div className="flex items-center space-x-4">
                    <Instagram className="w-6 h-6 text-pink-400" />
                    <p className="text-gray-300">Μέσω μηνύματος στο Instagram ή WhatsApp</p>
                  </div>
                  <div className="flex items-center space-x-4">
                    <Phone className="w-6 h-6 text-green-400" />
                    <p className="text-gray-300">Δυνατότητα τηλεφωνικής επικοινωνίας, εφόσον χρειαστεί</p>
                  </div>
                </div>
                
                <p className="text-lg text-white font-medium mt-6">
                  Αυτή η εμπειρία δεν είναι "μία ώρα και τέλος" — είναι πραγματική υποστήριξη, με αληθινό ενδιαφέρον για το πού πας και πώς θα φτάσεις εκεί.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Ideal For Section */}
        <section className="py-16 bg-dark-300">
          <div className="container mx-auto px-6 md:px-8 lg:px-12">
            <div className="max-w-6xl mx-auto">
              <div className="flex justify-center mb-8">
                <Target className="w-12 h-12 text-brand" />
              </div>
              <h3 className="text-3xl font-bold text-white text-center mb-12">
                Ιδανικό για
              </h3>
              
              <div className="grid md:grid-cols-2 gap-8">
                <div className="premium-card text-left">
                  <Users className="w-10 h-10 text-blue-400 mb-6" />
                  <h4 className="text-2xl font-bold text-white mb-6">Για μεμονωμένα άτομα</h4>
                  <ul className="space-y-3">
                    {["Δημιουργούς περιεχομένου που θέλουν να μονετάρουν", "Νέους freelancers που θέλουν να πουλήσουν υπηρεσίες", "Όσους θέλουν να στήσουν online παρουσία με δομή", "Όσους χρειάζονται ψυχολογική ενίσχυση & κατεύθυνση"].map((item, index) => <li key={index} className="flex items-start space-x-3">
                        <CheckCircle className="w-5 h-5 text-green-400 flex-shrink-0 mt-1" />
                        <span className="text-gray-300">{item}</span>
                      </li>)}
                  </ul>
                </div>
                
                <div className="premium-card text-left">
                  <Target className="w-10 h-10 text-purple-400 mb-6" />
                  <h4 className="text-2xl font-bold text-white mb-6">Για επιχειρήσεις</h4>
                  <ul className="space-y-3">
                    {["Μικρές και μεσαίες επιχειρήσεις που χρειάζονται digital στρατηγική", "Επαγγελματίες που θέλουν νέο positioning, funnel ή περιεχόμενο", "Ομάδες που χρειάζονται audit, plan & προσέγγιση πελατών", "Project owners που θέλουν να \"ξεμπλοκάρουν\" και να πάρουν πωλήσεις"].map((item, index) => <li key={index} className="flex items-start space-x-3">
                        <CheckCircle className="w-5 h-5 text-green-400 flex-shrink-0 mt-1" />
                        <span className="text-gray-300">{item}</span>
                      </li>)}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Topics Section */}
        <section className="py-16 bg-black">
          <div className="container mx-auto px-6 md:px-8 lg:px-12">
            <div className="max-w-4xl mx-auto">
              <div className="flex justify-center mb-8">
                <Lightbulb className="w-12 h-12 text-yellow-400" />
              </div>
              <h3 className="text-3xl font-bold text-white text-center mb-12">
                Θεματολογία Συνεδριών (ενδεικτικά)
              </h3>
              
              <div className="grid md:grid-cols-2 gap-4">
                {["Πώς να χτίσεις υπηρεσία & τη σελίδα της", "Πώς να στήσεις ad funnel με μικρό budget", "Πώς να προσελκύσεις τους σωστούς πελάτες", "Πώς να οργανώσεις τις προσφορές σου", "Πώς να χτίσεις personal ή business brand", "Στρατηγική Instagram ή TikTok περιεχομένου", "Πώς να αυξήσεις τιμές χωρίς να χάσεις κοινό", "Πώς να περάσεις από \"μπλοκαρισμένος\" → \"σε ροή\""].map((topic, index) => <div key={index} className="flex items-center space-x-3 p-4 bg-dark-300 rounded-lg">
                    <CheckCircle className="w-5 h-5 text-brand flex-shrink-0" />
                    <span className="text-gray-300">{topic}</span>
                  </div>)}
              </div>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-20 bg-gradient-to-r from-brand to-brand-hover">
          <div className="container mx-auto px-6 md:px-8 lg:px-12">
            <div className="text-center">
              <h3 className="text-3xl md:text-4xl font-bold text-white mb-8">
                Έτοιμος να κάνεις το επόμενο βήμα;
              </h3>
              <p className="text-xl text-white/90 mb-12 max-w-2xl mx-auto">
                Κλείσε τη συνεδρία σου και πάρε την καθοδήγηση που χρειάζεσαι για να προχωρήσεις με σιγουριά.
              </p>
              <Button asChild className="bg-white hover:bg-gray-100 text-brand font-bold text-xl px-12 py-8 rounded-lg shadow-2xl hover:shadow-3xl transition-all" size="lg">
                <a href="/contact">Κλείσε Συνεδρία – 97€</a>
              </Button>
            </div>
          </div>
        </section>
      </main>
      <Footer />
      <FloatingWhatsApp />
    </>;
};

export default Consulting;
